<template>
	<section class="other_page_banner trade_sec banner_nxt_sec_not_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.section_banner.title.one',
								)
							}}
						</h5>
						<h2>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.section_banner.main_title.one',
								)
							}}
						</h2>
						<p>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.section_banner.paragraph.one',
								)
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center"
						>
							<a href="#">
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.section_banner.cta_buttons.one',
									)
								}}
							</a>
							<a href="#" class="back_off">
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.section_banner.cta_buttons.two',
									)
								}}
							</a>
						</div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="creditcard_mid">
		<div class="container">
			<div class="row">
				<div class="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12">
					<div class="creditcard_inn">
						<span>{{
							$t(
								'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_lft_text.heading',
							)
						}}</span>
						<h6>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_lft_text.title.one',
								)
							}}
							<span>
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_lft_text.title.two',
									)
								}}
							</span>
						</h6>
						<p>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_lft_text.paragraph',
								)
							}}
						</p>
						<div class="starting_to_btn pay_world">
							<a href="/auth/register">
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_lft_text.cta_buttons',
									)
								}}
							</a>
						</div>
					</div>
				</div>
				<div class="col-xxl-4 col-xl-4 col-lg-4 col-md- col-sm-12 lady_off">
					<div class="credit_lady_mid">
						<img :src="img.image2" alt="" />
					</div>
				</div>
				<div class="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 lady_on">
					<div class="credit_lady_mid">
						<img :src="img.image5" alt="" />
					</div>
				</div>
				<div class="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12">
					<div class="creditcard_inn">
						<span>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_right_text.heading',
								)
							}}
						</span>
						<h6>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_right_text.title.one',
								)
							}}
							<span>
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_right_text.title.two',
									)
								}}
							</span>
						</h6>
						<p>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_right_text.paragraph.one',
								)
							}}
						</p>
						<p>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_right_text.paragraph.two',
								)
							}}
						</p>
						<div class="starting_to_btn pay_world">
							<a href="/auth/register">{{
								$t(
									'new_ui.personal_janopay_creditcard_page.creditcard_mid.creditcard_right_text.cta_buttons',
								)
							}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="credit_system">
		<div class="container">
			<div class="row">
				<div class="col-sm-6 border_dash">
					<div class="creditcard_system_inn credit_system_rt">
						<img class="d-block d-md-none" :src="img.image3" alt="" />
						<span>{{
							$t(
								'new_ui.personal_janopay_creditcard_page.credit_system_sec.label',
							)
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.credit_system_sec.title.one',
									)
								}}
								<br /><span>
									{{
										$t(
											'new_ui.personal_janopay_creditcard_page.credit_system_sec.title.two',
										)
									}}
								</span>
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.credit_system_sec.paragraph.one',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_janopay_creditcard_page.credit_system_sec.cta_buttons',
									)
								}}</a>
							</div>
							<img class="d-none d-md-block" :src="img.image3" alt="" />
						</div>
					</div>
				</div>
				<div class="col-sm-6 border_dash">
					<div class="creditcard_system_inn credit_system_rt">
						<img :src="img.image4" alt="" />
						<span>{{
							$t(
								'new_ui.personal_janopay_creditcard_page.credit_system_right_sec.label',
							)
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.credit_system_right_sec.title.one',
									)
								}}
								<br /><span>
									{{
										$t(
											'new_ui.personal_janopay_creditcard_page.credit_system_right_sec.title.two',
										)
									}}
								</span>
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.credit_system_right_sec.paragraph.one',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_janopay_creditcard_page.credit_system_right_sec.cta_buttons',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t(
								'new_ui.personal_janopay_creditcard_page.section_newsletter.label',
							)
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_janopay_creditcard_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_janopay_creditcard_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_janopay_creditcard_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_janopay_creditcard_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_janopay_creditcard_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import creditcard from '@/assets/images/sub/credit_card.png';
import creditlady from '@/assets/images/sub/credit_lady.png';
import cashboy from '@/assets/images/sub/cashboy.png';
import cardlapy from '@/assets/images/sub/card_lapy.png';
import creditladymob from '@/assets/images/sub/credit_ladymob.png';

export default {
	data: () => {
		return {
			img: {
				image1: creditcard,
				image2: creditlady,
				image3: cashboy,
				image4: cardlapy,
				image5: creditladymob,
			},
		};
	},
};
</script>
